import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';

const KEY = ['siteContact'];

export const useSiteContact = () =>
  useQuery({
    queryKey: KEY,
    queryFn: () => apiFetch('/api/site-contact'),
  });

export const useUpdateSiteContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiFetch('/api/site-contact/update', { method: 'PUT', body: data }),
    // Server returns { success, data: doc } and apiFetch unwraps to doc.
    onSuccess: (data) => {
      if (data) qc.setQueryData(KEY, data);
      else qc.invalidateQueries({ queryKey: KEY });
    },
  });
};
